import React from "react";
import "./TabFolder.scss";
import { IntroTab } from "../../Tabs/IntroTab/IntroTab";
import { ChatTab } from "../../Tabs/ChatTab/ChatTab";
import { ResultTab } from "../../Tabs/ResultTab/ResultTab";
import { useTranslation } from "react-i18next";

type Tab = 'info' | 'chat' | 'result';

interface IProps {
    activeTab: Tab;
}
export function TabFolder({activeTab = 'info'}: IProps) {
    const { t } = useTranslation();
    const activeTabElement = <><svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124 61"><defs></defs><g id="lip"><path style={{fill:'#cff0ff'}} d="m104,0H20C8.95,0,0,8.95,0,20v20h2l9.54,17.32c.91,1.66,2.66,2.69,4.55,2.68h91.82c1.89,0,3.63-1.03,4.55-2.68l9.54-17.32h2v-20c0-11.05-8.95-20-20-20Z"/><g id="Lip_lijn"><path d="m107.91,61H16.09c-2.07,0-3.98-1.13-4.98-2.94L1.7,41H0v-1h2.3l9.69,17.57c.83,1.5,2.4,2.43,4.11,2.43h91.82c1.71,0,3.28-.93,4.11-2.43l9.69-17.57h2.29v1h-1.71l-9.4,17.06c-1,1.82-2.91,2.94-4.98,2.94Z"/></g></g></svg></>;

    return (
        <div className="tab-folder-wrapper">
            <div className="tab-folder-header">
                <ul>
                    <li className={activeTab === 'info' ? 'active' : ''}>
                        <span>{t('game.tabs.info').toUpperCase()}</span>
                        {activeTabElement}
                    </li>
                    <li className={activeTab === 'chat' ? 'active' : ''}>
                        <span>{t('game.tabs.chat').toUpperCase()}</span>
                        {activeTabElement}
                    </li>
                    <li className={activeTab === 'result' ? 'active' : ''}>
                        <span>{t('game.tabs.result').toUpperCase()}</span>
                        {activeTabElement}
                    </li>
                </ul>
            </div>
            <div className="tab-folder-tabs" data-active={activeTab}>
                <div className="tab-folder-tab" data-tab={'info'}>
                    <IntroTab />
                </div>
                <div className="tab-folder-tab" data-tab={'chat'}>
                    <ChatTab />
                </div>
                <div className="tab-folder-tab" data-tab={'result'}>
                    <ResultTab />
                </div>
            </div>
        </div>
    )
}
